
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner, Flex } from "@chakra-ui/react";
import { useCognito } from "../utils/useCognito";

export default function AuthGuard({ children }) {
  const { isAuthenticated, isLoading } = useCognito();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate("/", { replace: true }); // redirect to login
    }
  }, [isLoading, isAuthenticated, navigate]);

  if (isLoading) {
    return (
      <Flex minH="100vh" align="center" justify="center">
        <Spinner size="xl" />
      </Flex>
    );
  }

  // If authenticated, render children
  return isAuthenticated ? children : null;
}
